/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Center_Errors_Report_IntroInputs */



/**
* | output |
* | --- |
* | "What I was doing when these errors appeared:" |
*
* @param {Activity_Center_Errors_Report_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_errors_report_intro = /** @type {((inputs?: Activity_Center_Errors_Report_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Errors_Report_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was ich gerade gemacht habe, als diese Fehler auftraten:")
	return /** @type {LocalizedString} */ ("What I was doing when these errors appeared:")
});